import { BlobFolderStatistics, FolderSummary } from "../types";

// Shown in place of a folder's statistics before they have been calculated.
export const STATISTICS_PLACEHOLDER = "—";

export const hasStatistics = (folder: FolderSummary): boolean =>
  folder.calculatedOn !== null;

// Soft-deleted blobs are still listed inside a folder, but the folder's file
// count only reflects files the user can still work with.
export const toFolderSummary = ({
  name,
  statistics,
}: {
  name: string;
  statistics: BlobFolderStatistics | null;
}): FolderSummary => ({
  name,
  fileCount: statistics ? statistics.blobCount - statistics.deletedCount : null,
  totalSize: statistics?.totalSize ?? null,
  archivedCount: statistics?.archivedCount ?? null,
  deletedCount: statistics?.deletedCount ?? null,
  lastModifiedOn: statistics?.lastModifiedOn ?? null,
  calculatedOn: statistics?.calculatedOn ?? null,
});
